import { render, staticRenderFns } from "./UserPortrait.vue?vue&type=template&id=a87bc2c0&scoped=true&"
import script from "./UserPortrait.vue?vue&type=script&lang=js&"
export * from "./UserPortrait.vue?vue&type=script&lang=js&"
import style0 from "./UserPortrait.vue?vue&type=style&index=0&id=a87bc2c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87bc2c0",
  null
  
)

export default component.exports